// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "privacy_purge_attempt".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "privacy_purge_attempt" table (1:1 with a DB row, on the wire). */
export const privacyPurgeAttemptAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    subjectType: z.string(),
    subjectId: z.string(),
    lastAttemptAt: z.string().datetime(),
    nextAttemptAt: z.string().datetime(),
    errorCode: z.string(),
});
//# sourceMappingURL=privacyPurgeAttempt.js.map